import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => ({ is_hovered: props.is_hovered }), [props.is_hovered])
}
